import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { SlidingPanel } from '@wix/wix-ui-premium-purchase';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { TransitionProps } from 'react-transition-group/Transition';
import { CheckoutPage } from '../../pages/CheckoutPage/CheckoutPage';
import { PlansPage } from '../../pages/PlansPage';
import { SubscriptionPage } from '../../pages/SubscriptionPage/SubscriptionPage';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { AdvancedPlansTitle as AppTitle } from '../AppTitle/AdvancedPlansTitle';
import { LoggedIn } from 'components/LoggedIn/LoggedIn';
import { PlanType } from 'enums';
import { Faq } from '../Faq';
import { AppController } from './App.controller';
import s from './App.scss';

export interface MultiProductAppProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}
const animationTimeouts: TransitionProps['timeout'] = {
  enter: 600,
  exit: 300,
};

const MultiProductAppComponent: React.FC<any> = (props) => {
  const controller = React.useMemo(() => new AppController(props), [
    props.rootStore.appStore,
  ]);
  const { onCycleSelect, onSelectProduct, fetchOrderPageFunction } = controller;
  const { theme } = usePageModeContext();
  const { currentStep, planType } = props.rootStore.appStore;

  const isEnterprisePlanType = planType === PlanType.Enterprise;

  return (
    <div className={classNames(s.headerAndContent, theme)}>
      <LoggedIn>{(isLoggedIn) => isLoggedIn && <AppTitle />}</LoggedIn>
      <div
        className={classNames(
          s.transitionContainer,
          s.panel,
          s.withBackgroundColor,
          theme,
        )}
      >
        <SlidingPanel
          activeChildIndex={currentStep}
          timeout={animationTimeouts}
        >
          <PlansPage onSelectProduct={onSelectProduct} />
          <SubscriptionPage
            data-hook='subscription-page'
            onCycleSelect={onCycleSelect}
          />
          <CheckoutPage fetchOrderPageData={fetchOrderPageFunction} />
        </SlidingPanel>
        {!isEnterprisePlanType && <Faq isEnterpriseFaqs={false} />}
      </div>
    </div>
  );
};

export const MultiProductApp = withInjectedRootStore(
  withExperiments(observer(MultiProductAppComponent)),
);
